// extracted by mini-css-extract-plugin
export default {"wrapper":"Y69nHe","path":"Jy0OgN"};